/**
 * @desc: - 选择投注位置
 * @param  {[ARRAY]}    value:        [当前选中值]
 * @param  {[FUNCTION]} onChange:     [点击变更值]
 * @author: ammo
 */
import ReactDOM from 'react-dom';

export default class Select extends React.Component {

  constructor(props) {
    super(props);
    this.handleOnchange = this.handleOnchange.bind(this);
    this.data = [
      {label: '万位', value: '1'},
      {label: '千位', value: '2'},
      {label: '百位', value: '3'},
      {label: '十位', value: '4'},
      {label: '个位', value: '5'}
    ]
  }

  // 输入变更
  handleOnchange(index){
    if (index === 'ignore') {return;}
    const {onChange, value} = this.props;
    value[index] = !value[index];
    onChange(value)
  }

  render() {
    const {value, pos} = this.props;
    return (
      <dl>
        <dt>选择位置:</dt>
          {
            this.data.map((item, index) => 
               <dd onClick={this.handleOnchange.bind(this, index)}  key={index} style={{display: pos.split('')[index] == '$' ? 'none' : ''}}>
                <input 
                  onChange={this.handleOnchange.bind(this, 'ignore')} 
                  type="checkbox" 
                  className="posChoose" 
                  value={item.value} 
                  checked={value[index]}/>
                {item.label}</dd>
            ) 
          }
      </dl>
    );
  }
}
